import http from "../utils/http";

export const getAlbumForRole = () => {
  return http.post("/albums/getAlbumForRole");
};

export const deleteImage = ({ type, imageUrl, serviceCode }) => {
  return http.post("/albums/deleteImage", {
    type,
    imageUrl,
    serviceCode,
  });
};

export const listFiles = () => {
  return http.get("/albums/listFiles");
};

export const upload = ({ file, code, prefix }) => {
  const data = new FormData();
  data.append("file", file);
  data.append("code", code);
  data.append("prefix", prefix);
  return http.post("/albums/upload", data, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
};

export const uploadFolder = ({ serviceCode, path }) => {
  return http.post("/albums/uploadFolder", { serviceCode, path });
};

export const remove = ({ code, imageUrl, thumbnailUrl }) => {
  return http.delete("/albums", {
    params: { code, imageUrl, thumbnailUrl },
  });
};

export const rename = ({ code, name }) => {
  return http.put("/albums/rename", {
    code, name
  })
}